import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class AutocompleteStylingModel extends CoreStylingModel {
/**
 * StylingModel for styling chips container
 */
chipsContainer: StylingModel;
/**
 * StylingModel for styling chips item
 */
chips: StylingModel;
/**
 * StylingModel for styling search container with input and dropdown
 */
searchContainer: StylingModel;
/**
 * StylingModel for styling input container
 */
inputContainer: StylingModel;
/**
 * StylingModel for styling input element
 */
input: StylingModel;
/**
 * StylingModel for styling dropdown container
 */
dropdownContainer: StylingModel;
/**
 * StylingModel for styling dropdown item
 */
dropdownItem: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
    if (this.chipsContainer == null) { this.chipsContainer = new StylingModel(); }
    if (this.chips == null) { this.chips = new StylingModel(); }
    if (this.searchContainer == null) { this.searchContainer = new StylingModel(); }
    if (this.inputContainer == null) { this.inputContainer = new StylingModel(); }
    if (this.input == null) { this.input = new StylingModel(); }
    if (this.dropdownContainer == null) { this.dropdownContainer = new StylingModel(); }
    if (this.dropdownItem == null) { this.dropdownItem = new StylingModel(); }
  }
}

function AutocompleteStylingModel_tsickle_Closure_declarations() {
/**
 * StylingModel for styling chips container
 * @type {?}
 */
AutocompleteStylingModel.prototype.chipsContainer;
/**
 * StylingModel for styling chips item
 * @type {?}
 */
AutocompleteStylingModel.prototype.chips;
/**
 * StylingModel for styling search container with input and dropdown
 * @type {?}
 */
AutocompleteStylingModel.prototype.searchContainer;
/**
 * StylingModel for styling input container
 * @type {?}
 */
AutocompleteStylingModel.prototype.inputContainer;
/**
 * StylingModel for styling input element
 * @type {?}
 */
AutocompleteStylingModel.prototype.input;
/**
 * StylingModel for styling dropdown container
 * @type {?}
 */
AutocompleteStylingModel.prototype.dropdownContainer;
/**
 * StylingModel for styling dropdown item
 * @type {?}
 */
AutocompleteStylingModel.prototype.dropdownItem;
}

